<template>
  <div :class="elementClasses">
    <form-label :label="label"
                :label-classes="labelClasses"
                :popover-text="popoverText"></form-label>

    <div :class="inputClasses">
      <input
        class="form-control"
        :class="{'is-invalid': error}"
        v-model.lazy="value_"/>

      <slot name="after-input"></slot>

      <div v-show="error" class="invalid-feedback">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
  import FormLabel from './FormLabel'

  export default {
    props: {
      inputClasses: {
        type: String,
        default: 'col-8 col-xl-9'
      },
      labelClasses: {
        type: String,
        default: 'col-form-label col-12 col-xl-3 text-muted'
      },
      elementClasses: {
        type: String,
        default: 'row form-group'
      },
      error: [String, Boolean],
      label: {
        type: String
      },
      popoverText: String,
      value: {
        required: true
      }
    },

    components: {
      'form-label': FormLabel
    },

    data() {
      return {
        value_: this.value,
        popoverTextId: null
      }
    },

    watch: {
      value_(val) {
        this.$emit('form-input', val)
      }
    }
  }
</script>
